module.exports = __webpack_public_path__ + "static/a5-96f67c0636a646de719fce632420dfdd.png";